let classNames = [
  'bg-slate-200',
  'bg-gray-200',
  'bg-zinc-200',
  'bg-neutral-200',
  'bg-stone-200',
  'bg-red-200',
  'bg-orange-200',
  'bg-amber-200',
  'bg-yellow-200',
  'bg-lime-200',
  'bg-green-200',
  'bg-emerald-200',
  'bg-teal-200',
  'bg-cyan-200',
  'bg-sky-200',
  'bg-blue-200',
  'bg-indigo-200',
  'bg-violet-200',
  'bg-purple-200',
  'bg-fuchsia-200',
  'bg-pink-200'
]

export function generateColor (name: string): string {
  let sum = 0

  for (let i = 0; i < name.length; i++) {
    sum += name.charCodeAt(i)
  }

  return classNames[sum % classNames.length] as string
}
